module.exports = ".expansion-footer {\n  justify-content: flex-start !important; }\n\n.current-node-title {\n  font-weight: bold; }\n"